export default __webpack_public_path__ + "static/media/steven.495efc4d.png";